import lodash from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'
import styled from 'styled-components'

import { useField } from '../../../../../../../../1stlog-ui/src/components/Field'
import { usePrevious } from '../../../../../../../../1stlog-ui/src/hooks'

const Wrapper = styled.div``

const TimeHandler = (props) => {
  const { timeOptions } = props

  const [selectedTime, setSelectedTime] = useField('selectedTime', {
    asState: true,
  })
  const [settings, setSettings] = useField('settings', { asState: true })

  useEffect(() => {
    // console.log("update default time", { selectedTime, timeOptions })
    if (
      !selectedTime ||
      !lodash.includes(
        lodash.map(timeOptions, (o) => o.id),
        selectedTime,
      )
    ) {
      // console.warn(
      //   "FIXME: defaultTime is not consistent - should be a simple string"
      // )
      // console.log("set selectedTime", { selectedTime, defaultTime })
      const defaultTime = lodash.first(lodash.map(timeOptions, (o) => o.id))
      setTimeout(() => setSelectedTime(defaultTime), 0)
    }
  }, [selectedTime, timeOptions])

  // set/update selected time option settings
  const previousSelectedTime = usePrevious(selectedTime)
  useEffect(() => {
    const option = lodash.find(timeOptions, (o) => o.id === selectedTime)
    if (!option) {
      return
    }
    // console.log("selectedTime changed", { selectedTime, option })

    // TODO: check if time settings are still okay

    const {
      from,
      until,
      additionalService,
      hideFromTime,
      hideUntilTime,
      startIsSelected,
    } = option
    const midnight = moment(from).hours(0).minutes(0).seconds(0).milliseconds(0)
    const actualFrom = startIsSelected ? from : midnight.toISOString()
    setTimeout(
      () =>
        setSettings({
          from: startIsSelected ? from : actualFrom,
          until,
          additionalService,
          hideFromTime,
          hideUntilTime,
        }),
      0,
    )
  }, [selectedTime, timeOptions])

  return null
}

export default TimeHandler
